import { FunctionComponent } from 'react';

import SelectModal, { SelectModalListItem } from '../index';

interface ReportSelectModalProps {
  isVisible: boolean;
  selectList: Array<SelectModalListItem>;
  onClose: () => void;
  title?: string;
}
const ReportSelectModal: FunctionComponent<ReportSelectModalProps> = ({
  isVisible,
  selectList,
  onClose,
  title = '신고하기',
}) => {
  return <>{isVisible && <SelectModal modalTitle={title} selectList={selectList} onClose={onClose} />}</>;
};

export default ReportSelectModal;
